import { assertDefined } from '@/utils/assertDefined';
import { getConfigurationsOnView } from '@/model/draft/getConfigurationsOnView';
import { getView } from '@/model/productType/getView';
import { selectConfigurations } from '@/redux/draft/getters/selectConfigurations';
import { StoreState } from '@/redux/types';
import { getErrorForConfiguration } from './getErrorForConfiguration';
import { getProductType } from './getProductType';

export function getConfigurationErrorsForView(state: StoreState, viewId: string) {
  const productType = getProductType(state);
  const view = assertDefined(getView(productType, viewId));
  const configurationsOnView = getConfigurationsOnView(selectConfigurations(state), view);
  return configurationsOnView
    .map((configuration) => getErrorForConfiguration(state, configuration))
    .filter(Boolean as any as <T>(x: T | undefined) => x is T);
}
